<template>
  <div class="add_body">
    <!--  <van-field v-model="text" label="收货人" />-->
    <!--  &lt;!&ndash; 输入手机号，调起手机号键盘 &ndash;&gt;-->
    <!--  <van-field v-model="tel" type="tel" label="手机号" />-->
    <!--  &lt;!&ndash; 允许输入正整数，调起纯数字键盘 &ndash;&gt;-->
    <!--  <van-field v-model="digit" type="digit" label="详细地址" />-->

    <!--  <div class="baocun"><van-button type="primary" block>保存</van-button></div>-->
    <van-address-edit
      :area-list="areaList"
      :address-info="AddressInfo"
      show-postal
      show-delete
      show-set-default
      show-search-result
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
    import {Toast} from 'vant';
    import areaList from './diqu';

    export default {
        name: "add_body",
        data() {
            return {
                tel: '',
                text: '',
                digit: '',
                areaList,
                searchResult: [],
                AddressInfo: {
                    areaCode: "",
                    name: "",
                    tel: "",
                    province: "",
                    city: "",
                    county: "",
                    addressDetail: "",
                    postalCode: "",
                    isDefault: "",
                },
                list: {}
            }
        },
        created() {
            console.log(2222)
            this.getxq()
        },
        methods: {
            onSave(AddressInfo) {
                if(this.$route.query.id==''){
                    this.myrequest({
                        url: '/client/addaddress.action',
                        types: 'post',
                        data: {
                            addressid: AddressInfo.areaCode,
                            name: AddressInfo.name,
                            mobile: AddressInfo.tel,
                            province_cn: AddressInfo.province,
                            city_cn: AddressInfo.city,
                            area_cn: AddressInfo.county,
                            address: AddressInfo.addressDetail,
                            yzmb: AddressInfo.postalCode,
                            ivs: AddressInfo.isDefault ? 1 : 0
                        },
                        succ: (res) => {
                            Toast.success('添加成功');
                            this.$router.go(-1)
                        },
                        errs: (msg) => {

                        }
                    })
                }else if(this.$route.query.id!=''){
                    this.myrequest({
                        url: '/client/addaddress.action',
                        types: 'post',
                        data: {
                            id:this.$route.query.id,
                            addressid: AddressInfo.areaCode,
                            name: AddressInfo.name,
                            mobile: AddressInfo.tel,
                            province_cn: AddressInfo.province,
                            city_cn: AddressInfo.city,
                            area_cn: AddressInfo.county,
                            address: AddressInfo.addressDetail,
                            yzmb: AddressInfo.postalCode,
                            ivs: AddressInfo.isDefault ? 1 : 0
                        },
                        succ: (res) => {
                            Toast.success('添加成功');
                            this.$router.go(-1)
                        },
                        errs: (msg) => {

                        }
                    })
                }

            },
            onDelete() {
                this.myrequest({
                    url: '/client/deladdress.action',
                    types: 'post',
                    data: {
                        // token:this.$store.state.token
                        id: this.$route.query.id
                    },
                    succ: (res) => {
                        this.$router.go(-1)
                    },
                    errs: (msg) => {

                    }
                })
            },
            getxq() {
                this.myrequest({
                    url: '/client/getaddressinfo.action',
                    types: 'get',
                    data: {
                        // token:this.$store.state.token
                        id: this.$route.query.id
                    },
                    succ: (res) => {
                        this.AddressInfo.areaCode = res.data.addressid
                        this.AddressInfo.name = res.data.name
                        this.AddressInfo.tel = res.data.mobile
                        this.AddressInfo.province = res.data.province_cn
                        this.AddressInfo.city = res.data.city_cn
                        this.AddressInfo.county = res.data.area_cn
                        this.AddressInfo.addressDetail = res.data.address
                        this.AddressInfo.postalCode = res.data.yzmb
                        this.AddressInfo.isDefault = res.data.ivs ? true:false

                    },
                    errs: (msg) => {

                    }
                })
            },


            onChangeDetail(val) {
                console.log(val, 222)
                // if (val) {
                //     this.searchResult = [
                //         {
                //             name: '黄龙万科中心',
                //             address: '杭州市西湖区',
                //         },
                //     ];
                // } else {
                //     this.searchResult = [];
                // }
            },
        },
        // components:{
        //     DIQU
        // }
    }
</script>

<style scoped lang="stylus">
  .add_body {
    position relative;
  }

  .baocun {
    width 100%;
    position fixed;
    bottom 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Shopping/address.vue